// Packages and components
import React, { useContext } from 'react';
import { Box } from 'grommet';
import { FormClose } from 'grommet-icons';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';
import styled from 'styled-components';

// Contexts and hooks
import { ResponsiveContext } from 'grommet';

// Styles
// @note: Don't do what Nick does here. These really should be their own feature components in their own files.
const SHDBackgroundImageGradient: typeof Box = styled(Box)`
  background-image: url(/pro/background_phone-tile-sidelinehd.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  z-index: 1;
  top: -45px;
  left: 0;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 0.2) 80%
    );
    z-index: 2;
  }
`;

const SHDSpacerGradient: typeof Box = styled(Box)`
  width: 100%;
  height: 50px;
  position: relative;
  z-index: 5;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 0) 100%
  );
`;

// Types and interfaces
interface SettingsCancelSubscriptionProps {
  numVideos: number;
  onCancelMembership: () => void;
  onClose: () => void;
}

const SettingsCancelSubscription: React.FC<SettingsCancelSubscriptionProps> = ({
  numVideos,
  onCancelMembership,
  onClose,
}) => {
  const screenSize = useContext(ResponsiveContext);

  return (
    <Box
      height={
        screenSize === 'small' || screenSize === 'medium' ? '100%' : '738px'
      }
    >
      <Box
        direction="row"
        onClick={() => onClose()}
        justify="end"
        style={{ position: 'absolute', right: '0', top: '-45px', zIndex: 10 }}
      >
        <Box pad={{ right: 'medium', top: 'medium' }}>
          <FormClose size="30px" color="black" />
        </Box>
      </Box>
      <SHDBackgroundImageGradient height="100%" width="100%" />

      <SHDFooter>
        <SHDSpacerGradient />
        <Box background="white" style={{ position: 'relative', zIndex: 3 }}>
          <SHDModalContainer gap="xlarge" isFirst>
            <SHDHeading level={3} margin="none">
              You are losing access to {String(numVideos)} videos, plus
            </SHDHeading>

            <Box gap="small" margin={{ bottom: 'xxsmall' }}>
              <Box direction="row" gap="xxsmall" align="start">
                <FormClose size="24px" color="black" />
                <SHDText style="subhead">
                  Automatic highlights & play-by-play videos
                </SHDText>
              </Box>

              <Box direction="row" gap="xxsmall" align="start">
                <FormClose size="24px" color="black" />
                <SHDText style="subhead">
                  Real-time text alerts and highlights for up to 5 phone numbers
                </SHDText>
              </Box>

              <Box direction="row" gap="xxsmall" align="start">
                <FormClose size="24px" color="black" />
                <SHDText style="subhead">
                  Unlimited access to your player&apos;s highlights with a
                  sharable profile link.
                </SHDText>
              </Box>
            </Box>
            <Box gap="xsmall">
              <SHDButton
                primary
                label="Keep my membership"
                onClick={() => {
                  onClose();
                }}
              />

              <SHDButton
                warning
                label="Cancel now"
                onClick={() => {
                  onCancelMembership();
                }}
              />
            </Box>
          </SHDModalContainer>
        </Box>
      </SHDFooter>
    </Box>
  );
};

export default SettingsCancelSubscription;
